import { Component, Injectable, computed, inject, input, signal } from '@angular/core';
import { splUiGradient } from '../../utils/gradient.util';

@Component({
  selector: 'spl-ui-avatar',
  imports: [],
  templateUrl: './avatar.html',
  styleUrl: './avatar.scss',
})
export class SplUiAvatar {
  readonly avatarService = inject(SplUiAvatarService);

  readonly userName = input.required<string>();
  readonly picture = input.required<string | null>();
  readonly gradientSeed = input.required<string>();

  readonly useGradient = computed(
    () => (!this.picture() || this.avatarService.pictureLoadFailed()) && splUiGradient(this.gradientSeed()),
  );

  readonly userInitials = computed(() =>
    this.userName()
      .split(' ', 2)
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase(),
  );

  handlePictureLoadFailure(): void {
    this.avatarService.pictureLoadFailed.set(true);
  }
}

@Injectable({
  providedIn: 'root',
})
class SplUiAvatarService {
  readonly pictureLoadFailed = signal(false);
}
